var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19777",
    "data-name": "Rectangle 19777",
    width: 13.402,
    height: 12.714,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_79325",
    "data-name": "Group 79325",
    transform: "translate(13046 7074)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19778",
    "data-name": "Rectangle 19778",
    width: 14,
    height: 14,
    transform: "translate(-13046 -7074)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_79324",
    "data-name": "Group 79324",
    transform: "translate(-13045.639 -7073.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79323",
    "data-name": "Group 79323",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80710",
    "data-name": "Path 80710",
    d: "M0,5.226A4.732,4.732,0,0,1,.947,2.461,5.824,5.824,0,0,1,3.668.3,3.756,3.756,0,0,1,6.295.183,2.614,2.614,0,0,1,8.1,2.3a4.235,4.235,0,0,1-.53,2.866,4.532,4.532,0,0,1-.359.574c-.08.106-.059.158.023.239Q8.352,7.083,9.461,8.2c.122.122.248.241.366.368.079.085.141.1.227.007q.268-.282.551-.549c.082-.078.064-.127-.009-.2-.215-.2-.436-.4-.631-.627-.212-.245-.214-.34-.008-.582a3.115,3.115,0,0,1,.573-.544.259.259,0,0,1,.4.028c.755.742,1.536,1.456,2.244,2.244.025.028.046.059.069.089.214.277.215.334-.025.583a3.892,3.892,0,0,1-.567.529.242.242,0,0,1-.323-.012,5.515,5.515,0,0,1-.72-.7c-.108-.117-.179-.115-.284,0-.16.176-.33.343-.5.5-.092.085-.081.138,0,.221.511.5,1,1.03,1.53,1.518a.9.9,0,0,1-.3,1.548.76.76,0,0,1-.936-.2c-.5-.507-1.007-1.005-1.51-1.509Q8.651,9.96,7.7,9c-.575-.576-1.153-1.15-1.727-1.728a.188.188,0,0,0-.289-.021,4.739,4.739,0,0,1-2,.866,3.181,3.181,0,0,1-2.6-.515A2.676,2.676,0,0,1,.064,5.95,3.928,3.928,0,0,1,0,5.226M6.613,3.068c0-.092,0-.184,0-.275a.326.326,0,0,0-.019-.078,1.531,1.531,0,1,0-2.94.841c.014.04.033.088,0,.124s-.076-.006-.115-.013A2.394,2.394,0,0,0,3.1,3.584,1.537,1.537,0,0,0,2.082,6.3a1.473,1.473,0,0,0,1.38.3,1.471,1.471,0,0,0,1.044-.97,1.547,1.547,0,0,0,0-1.015c-.011-.034-.041-.072,0-.1s.07,0,.1.012a1.649,1.649,0,0,0,.457.094A1.5,1.5,0,0,0,6.613,3.068",
    transform: "translate(-0.001 0.001)",
    fill: "#9c9c9c"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKey);
export default __webpack_public_path__ + "static/media/Key.7f9ce1aa64048205f1cc9a7aa098ef46.svg";
export { ForwardRef as ReactComponent };